import React from 'react';

import { Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';

export const styles = theme => ({
  groupTitle: {
    marginBottom: theme.spacing(2),
  },
});

/**
 * GroupTitle
 */
const GroupTitle = ({ classes = {}, label, children }) => {
  return (
    <>
      <Typography noWrap variant="h5" className={classes.groupTitle}>
        {label}
      </Typography>
      {children}
    </>
  );
};

GroupTitle.propTypes = {
  classes: PropTypes.object,
  label: PropTypes.string,
  children: PropTypes.node,
};

export default withStyles(styles)(GroupTitle);
